import { useLocation } from 'react-router-dom';
import {
  useGetPaginatedLocationsForTagEdit,
  useParamQuery,
  useUpdateLocations,
  useUpdateLocationTag,
} from 'src/hooks';
import { useGetLocationTagById } from 'src/hooks/api/locationTags/useGetLocationTagByID';
import { ILocation, ILocationTag } from 'src/interfaces';
import { formatQuery } from 'src/utils';

export const useEditLocationTagPage = (locationTagId: number) => {
  const { activeFilters, onChangeParams, getParamsValue } = useParamQuery({
    page: ['1'],
  });

  const location = useLocation();

  const pageParam = Number(getParamsValue('page')?.[0] || 1);
  const page = Number.isInteger(pageParam) && pageParam > 0 ? pageParam : 1;

  // Members-first virtual pagination: the hook returns the visible page slice
  // plus the *full* tag member set so the page can compute a tag-wide dirty
  // baseline (rather than a per-page one that would flip on every navigation).
  const { data, isLoading: isLoadingLocations } =
    useGetPaginatedLocationsForTagEdit(
      formatQuery(location.search),
      locationTagId,
      page,
    );

  const locations = data?.locations;
  const totalPages = data?.totalPages ?? 0;
  const totalCount = data?.totalCount ?? 0;
  const fullTaggedServerLocations = data?.fullTaggedServerLocations ?? [];

  const { data: tagById } = useGetLocationTagById(String(locationTagId), true);

  const handlePageChange = (
    _event: React.ChangeEvent<unknown>,
    value: number,
  ) => {
    onChangeParams('page', [`${value}`]);
  };

  const updateLocationTag = useUpdateLocationTag();
  const updateLocations = useUpdateLocations();

  const locationsBase = locations ? (locations as ILocation[]) : [];
  const selectedLocationTag = (tagById as ILocationTag) ?? {};

  return {
    locationsBase,
    fullTaggedServerLocations,
    isLoadingLocations,
    activeFilters,
    updateLocationTag,
    updateLocations,
    selectedLocationTag,
    totalPages,
    totalCount,
    page,
    handlePageChange,
    getParamsValue,
    locationsCount: tagById?.locations_count ?? 0,
  };
};
